import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-around;
`;

export default Container;
